export const enum Color {
  // Main
  white = "#FFFFFF",

  // Text
  textMain = "#00130A",
  textSecondary = "#575757",
  textDisabled = "#E4E4E4",

  // Border
  spaceGray = "#C3C5C7",
  spaceGrayHover = "#A9A9A9",

  // Light Gray
  lightGray = "#F7F7F7",
  lightGrayHover = "#EEEEEE",
  lightGrayDisabled = "#FCFCFC",

  // Opacity Sky
  opacitySky = "#F9FAFC",
  opacitySkyHover = "#EDEFF5",
  opacitySkyActive = "#A9BBCB",

  // Button - Primary
  primary = "#3F8E6A",
  primaryHover = "#27704F",
  primaryActive = "#226144",
  primaryDisabled = "#BFE6DE",

  // Button - Green Smoke
  greenSmoke = "#DDEAE4",
  greenSmokeHover = "#C6D9D0",
  greenSmokeActive = "#B0CBBE",
  greenSmokeDisabled = "#EEF4F1",

  // Button - Yellow
  yellow = "#FFAE35",
  yellowHover = "#E29C33",
  yellowActive = "#D89531",
  yellowDisabled = "#EBCA98",

  // Button - Danger
  danger = "#EF8763",
  dangerHover = "#DA7856",
  dangerActive = "#CC7050",
  dangerDisabled = "#F5BCA9",

  // Button - Red
  red = "#EE7766",
  redHover = "#D96959",
  redActive = "#CB6051",
  redDisabled = "#F6BBB2",

  // Toasts
  success = "#7FD059",

  // Planogram / UI Primitives
  sand50 = "#FCF7F0",
  sand300 = "#b1a391",
  sand500 = "#9a8b78",
  forest950 = "#001a13",
  purple100 = "#e2dcf3",
  gray400 = "#7d7d7d",
  gray500 = "#808080",
  gray800 = "#4c4c4c",
  sand700 = "#867763",
  pureYellow = "#ffff00",

  // Alert - High/Critical (Red)
  alertHighBg = "#FEF2F2",
  alertHighBorder = "#FECACA",
  alertHighText = "#7F1D1D",
  alertHighIcon = "#EF4444",
  alertHighBadgeBg = "#FEE2E2",
  alertHighBadgeText = "#B91C1C",
  alertCriticalText = "#991B1B",
  alertCriticalIcon = "#DC2626",

  // Alert - Medium (Orange)
  alertMediumBg = "#FFF7ED",
  alertMediumBorder = "#FED7AA",
  alertMediumText = "#7C2D12",
  alertMediumIcon = "#F97316",
  alertMediumBadgeBg = "#FFEDD5",
  alertMediumBadgeText = "#C2410C",

  // Alert - Low (Yellow)
  alertLowBg = "#FEFCE8",
  alertLowBorder = "#FEF08A",
  alertLowText = "#713F12",
  alertLowIcon = "#EAB308",
  alertLowBadgeBg = "#FEF3C7",
  alertLowBadgeText = "#A16207",

  // Warning
  warningBg = "#FFFBEB",
  warningText = "#92400E",
  warningIcon = "#D97706",

  // Success Status
  successBg = "#DCFCE7",
  successText = "#166534",
  successIcon = "#16A34A",
  successLight = "#22C55E",

  // Info / Blue
  infoBlue = "#3B82F6",
  infoBlueDark = "#1D4ED8",
  infoBlueDarker = "#2563EB",
  infoBlueBg = "#DBEAFE",
  infoBlueBgLight = "#EFF6FF",
  infoBlueText = "#1E40AF",
  infoBlueBorder = "#BFDBFE",

  // Purple
  purple = "#8B5CF6",
  purpleDark = "#6D28D9",
  purpleBg = "#EDE9FE",
  purpleBgLight = "#F5F3FF",
  purpleBorder = "#E9D5FF",

  // Success Light
  successBorder = "#BBF7D0",
  successBgLight = "#F0FDF4",
  successAccent = "#86EFAC",

  // Alert High Light
  alertHighBgLight = "#FEF2F280",
  alertHighAccent = "#FCA5A5",

  // Density / Space Allocation Status Bands (Primitives)
  emerald800 = "#065f46",
  emerald600 = "#059669",
  emerald500 = "#10b981",
  red200 = "#fca5a5",
  red500 = "#ef4444",
  red700 = "#b91c1c",

  // Mint
  mint = "#6EE7B7",
  mintBg = "#DCF0E8",

  // Grays
  gray100 = "#f3f4f6",
  gray200 = "#E5E7EB",
  gray300 = "#D1D5DB",
  gray600 = "#4B5563",
  gray700 = "#374151",

  // Amber
  amber = "#F59E0B",

  // Data Visualization Palette
  paletteOrange = "#E67E22",
  paletteRed = "#E74C3C",
  paletteTeal = "#1ABC9C",
  palettePurple = "#9B59B6",
  paletteDarkSlate = "#34495E",
  paletteGold = "#F39C12",
  paletteEmerald = "#2ECC71",
  paletteSkyBlue = "#3498DB",
  palettePink = "#E91E63",
  paletteIndigo = "#6366F1",
  palettePinkLight = "#EC4899",
  paletteTealDark = "#14B8A6",

  // CDT Level & Node Colors
  cdt2 = "#944514",
  cdt2Bg = "#FEF3C6",
  cdt2Border = "#FCDB6F",

  cdt3 = "#9D2839",
  cdt3Bg = "#FDE8E8",
  cdt3Border = "#FCB7B7",

  selectedNodeBg = "#4F46A8",
  selectedNodeBorder = "#3D3888",

  // Black
  black = "#000000",

  // Transparent
  transparent = "transparent",
}
